export default "__VITE_ASSET__f4ba4ad3__"